angular.module('components.caVolumeDiscountSelector', [])
    .component('caVolumeDiscountSelector', {
        templateUrl: 'main/product/pricelisteditor/components/volumediscountrule.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            priceRangeItem: '=',
            volumeDiscounts: '<'
        },
        controller: controller
    });

// @ngInject
function controller() {
    var vm = this;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;

    vm.changeVolumeDiscount = changeVolumeDiscount;
    vm.volumeDiscountAllowed = false;

    vm.selectedVolumeDiscount = {};

    function onInit() {
        vm.volumeDiscountAllowed = (vm.priceRangeItem !== undefined) ? vm.priceRangeItem.priceListId !== 0 && vm.priceRangeItem.isPriceOnAnyPriceList : false;

        if (vm.priceRangeItem !== undefined) {
            if (vm.priceRangeItem.volumeDiscounts !== undefined && vm.priceRangeItem.volumeDiscounts.length !== 0) {
                var firstVolumeDiscount = vm.priceRangeItem.volumeDiscounts[0];
                // If all volume discounts are the same
                if (_.every(vm.priceRangeItem.volumeDiscounts, function(vd) { return firstVolumeDiscount.id === vd.id; })) {
                    vm.selectedVolumeDiscount = firstVolumeDiscount;
                } else {
                    vm.selectedVolumeDiscount = generatePlaceholderVolumeDiscount(vm.priceRangeItem.volumeDiscounts);
                }
            } else {
                vm.selectedVolumeDiscount = _.find(vm.volumeDiscounts, function(vd) { return vd.id === 0; });
            }
        }
    }
    function onChanges() {

    }
    function onDestroy() {

    }

    function changeVolumeDiscount() {
        vm.priceRangeItem.volumeDiscounts.length = 0;
        vm.priceRangeItem.volumeDiscounts.push(vm.selectedVolumeDiscount);
    }

    function generatePlaceholderVolumeDiscount(volumeDiscounts) {
        var placeholderVolumeDiscount =  {
            id: -1,
            name: ""
        };

        var uniqueVolumeDiscounts = _.uniqBy(volumeDiscounts, function(vd) { return vd.name; });
        var firstLoop = true;
        _.forEach(uniqueVolumeDiscounts, function(vd) {
            if (firstLoop) {
                placeholderVolumeDiscount.name += vd.name;
                firstLoop = false;
            } else {
                placeholderVolumeDiscount.name += ", " + vd.name;
            }

        });

        return placeholderVolumeDiscount;
    }
}
